import { render } from "./QuizCompletionPage.vue?vue&type=template&id=75d04e6d&scoped=true"
import script from "./QuizCompletionPage.vue?vue&type=script&lang=js"
export * from "./QuizCompletionPage.vue?vue&type=script&lang=js"

import "./QuizCompletionPage.vue?vue&type=style&index=0&id=75d04e6d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d04e6d"]])

export default __exports__